module.exports = __webpack_public_path__ + "static/media/placeholder-icon.66b774f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/placeholder-icon.svg
// module id = 858
// module chunks = 0